import type { SetCurrentShopConfigChargeLimitPayload } from '@fourthwall/services/dist/ShopsApiClient'

import type { FormValues } from '../AddPaymentMethod.types'

export const getSetCurrentShopConfigChargeLimitPayload = (
  values: FormValues,
): SetCurrentShopConfigChargeLimitPayload => {
  if (!values.setChargeLimit) {
    return {
      chargePolicy: {
        type: 'NO_LIMIT',
      },
    }
  }

  return {
    chargePolicy: {
      type: 'LIMITED',
      amount: {
        currency: 'USD',
        value: parseFloat(values.chargeLimit),
      },
    },
  }
}
